/* eslint-disable @typescript-eslint/no-unused-expressions */
/* eslint-disable @typescript-eslint/no-shadow */
import React, { useEffect } from "react";
import { useDispatch } from "react-redux";
import { Redirect, Route, Switch, useHistory } from "react-router-dom";
import { useRouteMatch } from "react-router";
import { KButton } from "@kyburz/kdesign-system";
import {
  getCustomer,
  updateCustomer,
  updateCustomerPermissions,
} from "../../apiCalls/auth";
import BaseLayout from "../../components/layouts/BaseLayout";
import useSetState from "../../hooks/useSetState";
import General from "./General/General";
import Permissions from "./Permissions/Permissions";
import BasicSettings from "./BasicSettings/BasicSettings";
import { setAlert, setCustomer } from "../../redux/actions/actions";
import {
  getLanguageLabel,
  getLanguageValue,
} from "../../components/constants/languages";
import { rolePermissions } from "../../utils/permissions";
import { getConnectorDeereStatus } from "../../apiCalls/admin/connectorDeereAuth";
import JSONEditor from "../../components/JSONEditor/JSONEditor";
import { useStyles } from "./styles";
import InternalBillingTariffs from "./InternalBillingTariffs/InternalBillingTariffs";

const OrgSettings = () => {
  const dispatch = useDispatch();
  const classes = useStyles();
  const history = useHistory();
  const match = useRouteMatch({
    path: "/admin/settings/:activeTabURL",
    strict: true,
    sensitive: true,
  });
  const { activeTabURL } = match?.params as any;
  const tabs = [
    { label: "General", value: "general" },
    { label: "Roles", value: "roles" },
    { label: "Settings", value: "settings" },
    { label: "Reservation Settings", value: "reservationSettings" },
    { label: "Invoice settings", value: "invoiceSettings" },
    { label: "Notifications settings", value: "notificationsSettings" },
    { label: "Internal Billing Tariffs", value: "tariffs" },
  ];

  const currentCustomer = JSON.parse(
    localStorage.getItem("currentCustomer") || "",
  );

  const [
    {
      activeTab,
      currentCustomerData,
      shortname,
      timezone,
      name,
      language,
      logo,
      color,
      street,
      city,
      zip,
      country,
      archived,
      viewReservation,
      createReservation,
      adminReservation,
      unlimitedReservation,
      shareReservation,
      manageAttributesReport,
      viewDriver,
      createDriver,
      editDriver,
      deleteDriver,
      viewCompany,
      editCompany,
      createUsers,
      editUsers,
      deleteUsers,
      editRoles,
      createVehicles,
      editVehicles,
      deleteVehicles,
      viewHistory,
      viewHistoryParams,
      showPrivateData,
      setPrivateVehicles,
      viewIoTKeylessAccess,
      editIoTKeylessAccess,
      keylessAccess,
      keylessAccessAdmin,
      giveKeylessAccess,
      editGroups,
      editModels,
      viewDiagnosis,
      viewReports,
      reportJobsAdmin,
      viewTacho,
      tachoDownload,
      tachoScheduler,
      getVehicles,
      getVehicleGroups,
      sendNotifications,
      reservationOverviewField,
      supportNumber,
      keylessAccessExtraTimeMinutes,
      maxReservationTokenHours,
      maxReservationTimeMinutes,
      businessTrips,
      createDriverAutomatically,
      createDriverByDetectedId,
      prefillVehicleDataByVIN,
      filterVehiclesByTrackingDevice,
      tripsCutAtMidnight,
      viewPortalFrontend,
      sendFeedback,
      viewIncidents,
      createIncidents,
      editIncidents,
      deleteIncidents,
      viewRadius,
      viewTraces,
      viewAccurateWidth,
      editVehicleToFollow,
      viewDashboards,
      viewEco,
      viewDriverRanking,
      externalIdField,
      editExternalIdField,
      co2Values,
      viewFleetboxModule,
      createFleetbox,
      editFleetbox,
      deleteFleetbox,
      firmwareAdmin,
      showCanReserveFlag,
      display_attachments,
      viewInvoice,
      approveInvoice,
      releaseInvoice,
      viewReleaseInvoice,
      releaseInvoiceDealer,
      manageReleaseInvoice,
      viewActivity,
      viewOverview,
      viewFleetPage,
      viewVehicleTypes,
      createVehicleTypes,
      editVehicleTypes,
      deleteVehicleTypes,
      viewLogs,
      createLogs,
      rentalTariffsAdmin,
      rentalViewInvoices,
      rentalEditInvoices,
      sendSMSCommands,
      sendSMSCommandsAdmin,
      sendBridgeCommands,
      viewZones,
      createZones,
      editZones,
      deleteZones,
      viewDocuments,
      manageDocuments,
      deleteDocuments,
      manageReservationDocuments,
      customFieldsAdmin,
      viewResourcePlanner,
      viewContacts,
      createContacts,
      editContacts,
      deleteContacts,
      edit_third_party_reservation,
      connectorStatus,
      viewSearchByAttributes,
      reservationSettings,
      vehicleActivitySettings,
      notificationsSettings,
      viewTags,
      createTags,
      editTags,
      deleteTags,
      viewLSVA,
      manualCorrectLSVA,
      revokeLSVA,
      exportTo,
      internals,
      defaultTemplateId,
    },
    setState,
  ] = useSetState({
    activeTab: "general",
    currentCustomerData: {},
    shortname: "",
    timezone: "",
    name: "",
    language: "",
    logo: "",
    color: "#fff",
    street: "",
    city: "",
    zip: "",
    country: "",
    archived: false,
    viewReservation: false,
    createReservation: false,
    adminReservation: false,
    unlimitedReservation: false,
    shareReservation: false,
    manageAttributesReport: false,
    viewDriver: false,
    createDriver: false,
    editDriver: false,
    deleteDriver: false,
    viewCompany: false,
    editCompany: false,
    createUsers: false,
    editUsers: false,
    deleteUsers: false,
    editRoles: false,
    createVehicles: false,
    editVehicles: false,
    deleteVehicles: false,
    viewHistory: false,
    viewHistoryParams: false,
    showPrivateData: false,
    setPrivateVehicles: false,
    viewIoTKeylessAccess: false,
    editIoTKeylessAccess: false,
    keylessAccess: false,
    keylessAccessAdmin: false,
    giveKeylessAccess: false,
    editGroups: false,
    editModels: false,
    viewDiagnosis: false,
    viewReports: false,
    reportJobsAdmin: false,
    viewTacho: false,
    tachoDownload: false,
    tachoScheduler: false,
    getVehicles: false,
    getVehicleGroups: false,
    sendNotifications: true,
    reservationOverviewField: "driver",
    supportNumber: "",
    keylessAccessExtraTimeMinutes: 0,
    maxReservationTokenHours: 0,
    maxReservationTimeMinutes: null,
    businessTrips: true,
    createDriverAutomatically: true,
    createDriverByDetectedId: false,
    filterVehiclesByTrackingDevice: false,
    tripsCutAtMidnight: true,
    prefillVehicleDataByVIN: false,
    viewPortalFrontend: false,
    sendFeedback: false,
    viewIncidents: false,
    createIncidents: false,
    editIncidents: false,
    deleteIncidents: false,
    viewRadius: false,
    viewTraces: false,
    viewAccurateWidth: false,
    editVehicleToFollow: false,
    viewDashboards: false,
    viewEco: false,
    viewDriverRanking: false,
    externalIdField: null,
    editExternalIdField: true,
    co2Values: {},
    createFleetbox: false,
    deleteFleetbox: false,
    editFleetbox: false,
    viewFleetboxModule: false,
    firmwareAdmin: false,
    showCanReserveFlag: false,
    display_attachments: "auto",
    viewInvoice: false,
    approveInvoice: false,
    releaseInvoice: false,
    viewReleaseInvoice: false,
    releaseInvoiceDealer: false,
    manageReleaseInvoice: false,
    viewActivity: false,
    viewOverview: false,
    viewFleetPage: false,
    viewVehicleTypes: false,
    createVehicleTypes: false,
    editVehicleTypes: false,
    deleteVehicleTypes: false,
    viewLogs: false,
    createLogs: false,
    rentalTariffsAdmin: false,
    rentalViewInvoices: false,
    rentalEditInvoices: false,
    sendSMSCommands: false,
    sendSMSCommandsAdmin: false,
    sendBridgeCommands: false,
    viewZones: false,
    createZones: false,
    editZones: false,
    deleteZones: false,
    viewDocuments: false,
    manageDocuments: false,
    deleteDocuments: false,
    manageReservationDocuments: false,
    customFieldsAdmin: false,
    viewResourcePlanner: false,
    viewContacts: false,
    createContacts: false,
    editContacts: false,
    deleteContacts: false,
    edit_third_party_reservation: false,
    connectorStatus: {},
    viewSearchByAttributes: false,
    reservationSettings: null,
    vehicleActivitySettings: null,
    notificationsSettings: null,
    viewTags: false,
    createTags: false,
    editTags: false,
    deleteTags: false,
    viewLSVA: false,
    manualCorrectLSVA: false,
    revokeLSVA: false,
    exportTo: [],
    defaultTemplateId: null,
    internals: {},
  });

  const roles = {
    viewReservation,
    createReservation,
    adminReservation,
    edit_third_party_reservation,
    unlimitedReservation,
    shareReservation,
    manageAttributesReport,
    viewDriver,
    createDriver,
    editDriver,
    deleteDriver,
    viewCompany,
    editCompany,
    createUsers,
    editUsers,
    deleteUsers,
    editRoles,
    createVehicles,
    editVehicles,
    deleteVehicles,
    viewHistory,
    viewHistoryParams,
    showPrivateData,
    setPrivateVehicles,
    viewIoTKeylessAccess,
    editIoTKeylessAccess,
    keylessAccess,
    keylessAccessAdmin,
    giveKeylessAccess,
    editGroups,
    editModels,
    viewDiagnosis,
    viewReports,
    reportJobsAdmin,
    viewTacho,
    tachoDownload,
    tachoScheduler,
    getVehicles,
    getVehicleGroups,
    viewPortalFrontend,
    sendFeedback,
    viewIncidents,
    createIncidents,
    editIncidents,
    deleteIncidents,
    viewRadius,
    viewTraces,
    viewAccurateWidth,
    editVehicleToFollow,
    viewDashboards,
    viewEco,
    viewDriverRanking,
    createFleetbox,
    deleteFleetbox,
    editFleetbox,
    viewFleetboxModule,
    firmwareAdmin,
    viewInvoice,
    approveInvoice,
    releaseInvoice,
    viewReleaseInvoice,
    releaseInvoiceDealer,
    manageReleaseInvoice,
    viewActivity,
    viewOverview,
    viewFleetPage,
    viewVehicleTypes,
    createVehicleTypes,
    editVehicleTypes,
    deleteVehicleTypes,
    viewLogs,
    createLogs,
    rentalTariffsAdmin,
    rentalViewInvoices,
    rentalEditInvoices,
    sendSMSCommands,
    sendSMSCommandsAdmin,
    sendBridgeCommands,
    viewZones,
    createZones,
    editZones,
    deleteZones,
    viewDocuments,
    manageDocuments,
    deleteDocuments,
    manageReservationDocuments,
    customFieldsAdmin,
    viewResourcePlanner,
    viewContacts,
    createContacts,
    editContacts,
    deleteContacts,
    viewSearchByAttributes,
    viewTags,
    createTags,
    editTags,
    deleteTags,
    viewLSVA,
    manualCorrectLSVA,
    revokeLSVA,
  };

  const permissions = rolePermissions(
    viewReservation,
    createReservation,
    adminReservation,
    edit_third_party_reservation,
    unlimitedReservation,
    shareReservation,
    manageAttributesReport,
    viewDriver,
    createDriver,
    editDriver,
    deleteDriver,
    viewCompany,
    editCompany,
    createUsers,
    editUsers,
    deleteUsers,
    editRoles,
    createVehicles,
    editVehicles,
    deleteVehicles,
    viewHistory,
    viewHistoryParams,
    showPrivateData,
    setPrivateVehicles,
    viewIoTKeylessAccess,
    editIoTKeylessAccess,
    keylessAccess,
    keylessAccessAdmin,
    giveKeylessAccess,
    editGroups,
    editModels,
    viewDiagnosis,
    viewReports,
    reportJobsAdmin,
    viewTacho,
    tachoDownload,
    tachoScheduler,
    getVehicles,
    getVehicleGroups,
    viewPortalFrontend,
    sendFeedback,
    viewIncidents,
    createIncidents,
    editIncidents,
    deleteIncidents,
    viewRadius,
    viewTraces,
    viewAccurateWidth,
    editVehicleToFollow,
    viewDashboards,
    viewEco,
    viewDriverRanking,
    createFleetbox,
    deleteFleetbox,
    editFleetbox,
    viewFleetboxModule,
    firmwareAdmin,
    viewInvoice,
    approveInvoice,
    releaseInvoice,
    viewActivity,
    viewOverview,
    viewFleetPage,
    viewVehicleTypes,
    createVehicleTypes,
    editVehicleTypes,
    deleteVehicleTypes,
    viewLogs,
    createLogs,
    rentalTariffsAdmin,
    rentalViewInvoices,
    rentalEditInvoices,
    sendSMSCommands,
    sendSMSCommandsAdmin,
    sendBridgeCommands,
    viewZones,
    createZones,
    editZones,
    deleteZones,
    viewDocuments,
    manageDocuments,
    deleteDocuments,
    manageReservationDocuments,
    customFieldsAdmin,
    viewResourcePlanner,
    viewContacts,
    createContacts,
    editContacts,
    deleteContacts,
    viewSearchByAttributes,
    viewReleaseInvoice,
    releaseInvoiceDealer,
    manageReleaseInvoice,
    viewTags,
    createTags,
    editTags,
    deleteTags,
    viewLSVA,
    manualCorrectLSVA,
    revokeLSVA,
  );

  const handleToggle = (e) =>
    setState({
      [e.target.name]: e.target.checked,
    });

  const handleSelectChange = (name, value): void => {
    setState({ [name]: value.value });
  };

  const handleFieldChange = (name, value): void => {
    setState({ [name]: value });
  };

  const handleTextInputChange = (e) => {
    setState({ [e.target.name]: e.target.value });
  };

  const handleCO2ValueChange = (e) => {
    setState({
      co2Values: {
        ...co2Values,
        [e.target.name]: e.target.value
          ? parseFloat(e.target.value) ?? null
          : null,
      },
    });
  };

  const handleJSONChange = (name: string, json: string) => {
    try {
      JSON.parse(json);
    } catch (e) {
      return;
    }
    const parsedJson = JSON.parse(json);
    handleFieldChange(name, parsedJson);
  };

  const handleReservationConfigChange = (json: string) =>
    handleJSONChange("reservationSettings", json);

  const handleInvoiceConfigChange = (json: string) =>
    handleJSONChange("vehicleActivitySettings", json);

  const handleNotificationsConfigChange = (json: string) =>
    handleJSONChange("notificationsSettings", json);

  const setLogo = (url) => {
    setState({ logo: url });
  };

  const handleColorChange = (color) => {
    if (color.hex !== null) {
      setState({ color: color?.hex });
    }
  };

  const handleInternalsChange = (value: Record<any, any>) =>
    setState({
      internals: {
        ...internals,
        ...value,
      },
    });

  const handleTogglePermissions = (value) => {
    setState({ [value.name]: !value.value });
  };

  const getCustomerData = () => {
    if (currentCustomer?.shortname) {
      getCustomer(currentCustomer?.shortname).then((res) => {
        setState({ currentCustomerData: res.data });
        localStorage.setItem("currentCustomer", JSON.stringify(res.data));
        dispatch(setCustomer(res.data));
      });
    }
  };

  const getConnectorStatus = () => {
    getConnectorDeereStatus(currentCustomer?.shortname)
      .then((res) => {
        if (res) {
          setState({ connectorStatus: res });
        } else {
          setState({ connectorStatus: {} });
        }
      })
      .catch(() => {
        setState({ connectorStatus: {} });
      });
  };

  useEffect(() => {
    setState({ activeTab: activeTabURL });
    getCustomerData();
    getConnectorStatus();
  }, []);

  useEffect(() => {
    if (adminReservation) {
      setState({ createReservation: true });
    }
    if (!viewReservation) {
      setState({
        createReservation: false,
        adminReservation: false,
        unlimited_reservation: false,
        share_reservation: false,
        manageAttributesReport: false,
      });
    }
    if (!viewDriver) {
      setState({ createDriver: false, editDriver: false, deleteDriver: false });
    }
    if (!viewZones) {
      setState({ createZones: false, editZones: false, deleteZones: false });
    }
    if (!viewDocuments) {
      setState({
        manageDocuments: false,
        deleteDocuments: false,
        manageReservationDocuments: false,
      });
    }
    if (!viewTags) {
      setState({
        createTags: false,
        editTags: false,
        deleteTags: false,
      });
    }
    if (!viewContacts) {
      setState({
        createContacts: false,
        editContacts: false,
        deleteContacts: false,
      });
    }
    if (!viewCompany) {
      setState({
        editCompany: false,
        createUsers: false,
        editUsers: false,
        deleteUsers: false,
        editRoles: false,
        createVehicles: false,
        editVehicles: false,
        deleteVehicles: false,
        editGroups: false,
        editModels: false,
      });
    }
  }, [
    adminReservation,
    viewReservation,
    shareReservation,
    manageAttributesReport,
    viewDriver,
    viewCompany,
    createReservation,
    viewZones,
    viewContacts,
    viewDocuments,
    viewTags,
  ]);

  useEffect(() => {
    if (currentCustomerData && Object.keys(currentCustomerData)?.length !== 0) {
      setState({
        shortname: currentCustomerData?.shortname,
        timezone: currentCustomerData?.timezone,
        name: currentCustomerData?.name,
        language: getLanguageLabel(currentCustomerData?.language),
        logo: currentCustomerData?.logo,
        color: currentCustomerData?.color,
        street: currentCustomerData?.address?.street,
        city: currentCustomerData?.address?.city,
        zip: currentCustomerData?.address?.zip,
        archived: currentCustomerData?.archived,
        country: currentCustomerData?.address?.country,
        exportTo: currentCustomerData?.settings?.export_settings?.export_to,
        internals: currentCustomerData?.company_internals,
        defaultTemplateId: currentCustomerData?.settings?.default_template_id,
        viewReservation:
          currentCustomerData?.module_permissions?.reservation_module
            ?.view_module,
        createReservation:
          currentCustomerData?.module_permissions?.reservation_module
            ?.create_reservation,
        adminReservation:
          currentCustomerData?.module_permissions?.reservation_module
            ?.create_interrupting_reservation,
        edit_third_party_reservation:
          currentCustomerData?.module_permissions?.reservation_module
            ?.edit_third_party_reservation,
        unlimitedReservation:
          currentCustomerData?.module_permissions?.reservation_module
            ?.unlimited_reservation,
        shareReservation:
          currentCustomerData?.module_permissions?.reservation_module
            ?.share_reservation,
        manageAttributesReport:
          currentCustomerData?.module_permissions?.reservation_module
            ?.manage_attributes_report,
        viewDriver:
          currentCustomerData?.module_permissions?.drivers_module?.view_module,
        createDriver:
          currentCustomerData?.module_permissions?.drivers_module
            ?.create_driver,
        editDriver:
          currentCustomerData?.module_permissions?.drivers_module?.edit_driver,
        deleteDriver:
          currentCustomerData?.module_permissions?.drivers_module
            ?.delete_driver,
        viewCompany:
          currentCustomerData?.module_permissions?.company_settings_module
            ?.view_module,
        editCompany:
          currentCustomerData?.module_permissions?.company_settings_module
            ?.edit_company_settings,
        createUsers:
          currentCustomerData?.module_permissions?.company_settings_module
            ?.add_user,
        editUsers:
          currentCustomerData?.module_permissions?.company_settings_module
            ?.edit_user,
        deleteUsers:
          currentCustomerData?.module_permissions?.company_settings_module
            ?.delete_user,
        editRoles:
          currentCustomerData?.module_permissions?.company_settings_module
            ?.edit_role,
        createVehicles:
          currentCustomerData?.module_permissions?.vehicles_module
            ?.create_vehicle,
        editVehicles:
          currentCustomerData?.module_permissions?.vehicles_module
            ?.edit_vehicle,
        deleteVehicles:
          currentCustomerData?.module_permissions?.vehicles_module
            ?.delete_vehicle,
        viewHistory:
          currentCustomerData?.module_permissions?.vehicles_module
            ?.view_history,
        viewHistoryParams:
          currentCustomerData?.module_permissions?.vehicles_module
            ?.view_history_params,
        showPrivateData:
          currentCustomerData?.module_permissions?.vehicles_module
            ?.view_private_telemetry_data,
        setPrivateVehicles:
          currentCustomerData?.module_permissions?.vehicles_module
            ?.edit_private_state,
        viewIoTKeylessAccess:
          currentCustomerData?.module_permissions?.iot_devices_module
            ?.view_module,
        editIoTKeylessAccess:
          currentCustomerData?.module_permissions?.iot_devices_module
            ?.manage_iot_devices,
        keylessAccess:
          currentCustomerData?.module_permissions?.reservation_module
            ?.keyless_access,
        keylessAccessAdmin:
          currentCustomerData?.module_permissions?.reservation_module
            ?.keyless_access_admin,
        giveKeylessAccess:
          currentCustomerData?.module_permissions?.reservation_module
            ?.keyless_access_give_access,
        editGroups:
          currentCustomerData?.module_permissions?.vehicles_module
            ?.edit_vehicle_group,
        editModels:
          currentCustomerData?.module_permissions?.vehicles_module
            ?.edit_vehicle_model,
        viewDiagnosis:
          currentCustomerData?.module_permissions?.diagnosis_module
            ?.view_module,
        viewReports:
          currentCustomerData?.module_permissions?.reporting_module
            ?.view_module,
        reportJobsAdmin:
          currentCustomerData?.module_permissions?.reporting_module
            ?.report_jobs_admin,
        viewTacho:
          currentCustomerData?.module_permissions?.tacho_module?.view_module,
        tachoDownload:
          currentCustomerData?.module_permissions?.tacho_module?.tacho_download,
        tachoScheduler:
          currentCustomerData?.module_permissions?.tacho_module
            ?.tacho_scheduler,
        getVehicles:
          currentCustomerData?.module_permissions?.vehicles_module
            ?.get_vehicles,
        getVehicleGroups:
          currentCustomerData?.module_permissions?.vehicles_module
            ?.get_vehicle_groups,
        sendNotifications: currentCustomerData?.settings?.send_notifications,
        supportNumber: currentCustomerData?.settings?.technical_support_number,
        keylessAccessExtraTimeMinutes:
          currentCustomerData?.settings?.keyless_access_extra_time_minutes,
        maxReservationTokenHours:
          currentCustomerData?.settings?.max_reservation_token_hours || 0,
        reservationOverviewField:
          currentCustomerData?.settings?.reservation_overview_field,
        maxReservationTimeMinutes:
          currentCustomerData?.settings?.max_reservation_time_minutes,
        businessTrips:
          currentCustomerData?.settings?.reservation_show_business_trips_toggle,
        showCanReserveFlag:
          currentCustomerData?.settings?.setup_user_rights_in_group,
        createDriverAutomatically:
          currentCustomerData?.settings?.create_driver_on_user_creation,
        createDriverByDetectedId:
          currentCustomerData?.settings?.create_driver_by_detected_id,
        filterVehiclesByTrackingDevice:
          currentCustomerData?.settings
            ?.show_vehicles_only_with_tracking_device,
        tripsCutAtMidnight:
          currentCustomerData?.settings?.trips_cut_at_midnight,
        prefillVehicleDataByVIN:
          currentCustomerData?.settings?.prefill_vehicle_data_by_vin,
        externalIdField: currentCustomerData?.settings?.external_id_field,
        display_attachments: currentCustomerData?.settings?.display_attachments,
        editExternalIdField: !!currentCustomerData?.settings?.external_id_field,
        viewPortalFrontend:
          currentCustomerData?.module_permissions?.frontend_module?.view_portal,
        sendFeedback:
          currentCustomerData?.module_permissions?.frontend_module
            ?.send_feedback,
        viewIncidents:
          currentCustomerData?.module_permissions?.incidents_module
            ?.view_module,
        createIncidents:
          currentCustomerData?.module_permissions?.incidents_module
            ?.create_incident,
        editIncidents:
          currentCustomerData?.module_permissions?.incidents_module
            ?.edit_incident,
        deleteIncidents:
          currentCustomerData?.module_permissions?.incidents_module
            ?.delete_incident,
        viewRadius:
          currentCustomerData?.module_permissions?.radius_module?.view_module,
        viewTraces:
          currentCustomerData?.module_permissions?.radius_module?.view_traces,
        viewAccurateWidth:
          currentCustomerData?.module_permissions?.radius_module
            ?.view_accurate_width,
        editVehicleToFollow:
          currentCustomerData?.module_permissions?.radius_module
            ?.edit_vehicle_to_follow,
        viewDashboards:
          currentCustomerData?.module_permissions?.dashboard_module
            ?.view_module,
        viewEco:
          currentCustomerData?.module_permissions?.dashboard_module?.view_eco,
        viewDriverRanking:
          currentCustomerData?.module_permissions?.dashboard_module
            ?.view_driver_ranking,
        co2Values: currentCustomerData?.settings?.co2_values,
        createFleetbox:
          currentCustomerData?.module_permissions?.fleetbox_module
            ?.create_fleetbox,
        deleteFleetbox:
          currentCustomerData?.module_permissions?.fleetbox_module
            ?.delete_fleetbox,
        editFleetbox:
          currentCustomerData?.module_permissions?.fleetbox_module
            ?.edit_fleetbox,
        viewFleetboxModule:
          currentCustomerData?.module_permissions?.fleetbox_module?.view_module,
        firmwareAdmin:
          currentCustomerData?.module_permissions?.fleetbox_module
            ?.firmware_admin,
        viewInvoice:
          currentCustomerData?.module_permissions?.invoice_module?.view_module,
        approveInvoice:
          currentCustomerData?.module_permissions?.invoice_module
            ?.approve_invoice,
        releaseInvoice:
          currentCustomerData?.module_permissions?.invoice_module
            ?.release_invoice,
        viewReleaseInvoice:
          currentCustomerData?.module_permissions?.invoice_module
            ?.view_release_invoice,
        releaseInvoiceDealer:
          currentCustomerData?.module_permissions?.invoice_module
            ?.release_invoice_dealer,
        manageReleaseInvoice:
          currentCustomerData?.module_permissions?.invoice_module
            ?.manage_release_invoice,
        viewActivity:
          currentCustomerData?.module_permissions?.activity_module?.view_module,
        viewOverview:
          currentCustomerData?.module_permissions?.overview_module?.view_module,
        viewFleetPage:
          currentCustomerData?.module_permissions?.fleet_module?.view_module,
        viewVehicleTypes:
          currentCustomerData?.module_permissions?.vehicles_module
            ?.get_vehicle_types,
        createVehicleTypes:
          currentCustomerData?.module_permissions?.vehicles_module
            ?.create_vehicle_type,
        editVehicleTypes:
          currentCustomerData?.module_permissions?.vehicles_module
            ?.edit_vehicle_type,
        deleteVehicleTypes:
          currentCustomerData?.module_permissions?.vehicles_module
            ?.delete_vehicle_type,
        viewLogs:
          currentCustomerData?.module_permissions?.log_module?.view_module,
        createLogs:
          currentCustomerData?.module_permissions?.log_module?.create_log,
        rentalTariffsAdmin:
          currentCustomerData?.module_permissions?.rental_module
            ?.rental_tariff_admin,
        rentalViewInvoices:
          currentCustomerData?.module_permissions?.rental_module?.view_invoices,
        rentalEditInvoices:
          currentCustomerData?.module_permissions?.rental_module?.edit_invoices,
        sendSMSCommands:
          currentCustomerData?.module_permissions?.fleetbox_module
            ?.send_sms_command,
        sendSMSCommandsAdmin:
          currentCustomerData?.module_permissions?.fleetbox_module
            ?.send_sms_command_admin,
        sendBridgeCommands:
          currentCustomerData?.module_permissions?.fleetbox_module
            ?.send_bridge_command,
        viewZones:
          currentCustomerData?.module_permissions?.geozones_module?.view_module,
        createZones:
          currentCustomerData?.module_permissions?.geozones_module?.create_zone,
        editZones:
          currentCustomerData?.module_permissions?.geozones_module?.edit_zone,
        deleteZones:
          currentCustomerData?.module_permissions?.geozones_module?.delete_zone,
        viewDocuments:
          currentCustomerData?.module_permissions?.documents_module
            ?.view_module,
        manageDocuments:
          currentCustomerData?.module_permissions?.documents_module
            ?.manage_document,
        deleteDocuments:
          currentCustomerData?.module_permissions?.documents_module
            ?.delete_document,
        manageReservationDocuments:
          currentCustomer?.module_permissions?.documents_module
            ?.manage_reservation_document,
        customFieldsAdmin:
          currentCustomerData?.module_permissions?.custom_fields_module
            ?.custom_fields_admin,
        viewResourcePlanner:
          currentCustomerData?.module_permissions?.resource_planner_module
            ?.view_module,
        viewContacts:
          currentCustomerData?.module_permissions?.contacts_module?.view_module,
        createContacts:
          currentCustomerData?.module_permissions?.contacts_module
            ?.create_contact,
        editContacts:
          currentCustomerData?.module_permissions?.contacts_module
            ?.edit_contact,
        deleteContacts:
          currentCustomerData?.module_permissions?.contacts_module
            ?.delete_contact,

        viewSearchByAttributes:
          currentCustomerData?.module_permissions?.search_module
            ?.view_search_by_attributes,
        reservationSettings:
          currentCustomerData?.settings?.reservation_settings,
        vehicleActivitySettings:
          currentCustomerData?.settings?.vehicle_activity_settings,
        notificationsSettings:
          currentCustomerData?.settings?.notifications_settings,
        viewTags:
          currentCustomerData?.module_permissions?.tags_module?.view_module,
        createTags:
          currentCustomerData?.module_permissions?.tags_module?.create_tag,
        editTags:
          currentCustomerData?.module_permissions?.tags_module?.edit_tag,
        deleteTags:
          currentCustomerData?.module_permissions?.tags_module?.delete_tag,
        viewLSVA:
          currentCustomerData?.module_permissions?.lsva_module?.view_module,
        manualCorrectLSVA:
          currentCustomerData?.module_permissions?.lsva_module
            ?.create_manual_corrections,
        revokeLSVA:
          currentCustomerData?.module_permissions?.lsva_module
            ?.revoke_manual_corrections,
      });
    }
  }, [currentCustomerData]);

  const handleTabClick = (event, newValue) => {
    history.push(`/admin/settings/${newValue}`);
    setState({ activeTab: newValue });
  };

  const handleCustomerUpdate = () => {
    const newCustomerData = {
      ...currentCustomerData,
      name,
      logo,
      color,
      language: getLanguageValue(language),
      address: {
        street,
        city,
        zip,
        country,
      },
      archived,
      company_internals: {
        ...currentCustomerData.internals,
        ...internals,
      },
      settings: {
        ...currentCustomerData.settings,
        send_notifications: sendNotifications,
        prefill_vehicle_data_by_vin: prefillVehicleDataByVIN,
        send_feedback: sendFeedback,
        reservation_overview_field: reservationOverviewField,
        technical_support_number: supportNumber,
        keyless_access_extra_time_minutes: Number(
          keylessAccessExtraTimeMinutes,
        ),
        max_reservation_token_hours: Number(maxReservationTokenHours) || null,
        max_reservation_time_minutes: maxReservationTimeMinutes || null,
        reservation_show_business_trips_toggle: businessTrips,
        setup_user_rights_in_group: showCanReserveFlag,
        show_vehicles_only_with_tracking_device: filterVehiclesByTrackingDevice,
        trips_cut_at_midnight: tripsCutAtMidnight,
        create_driver_on_user_creation: createDriverAutomatically,
        create_driver_by_detected_id: createDriverByDetectedId,
        external_id_field: externalIdField,
        co2_values: co2Values,
        display_attachments,
        reservation_settings: reservationSettings,
        vehicle_activity_settings: vehicleActivitySettings,
        notifications_settings: notificationsSettings,
        export_settings: {
          ...currentCustomerData.export_settings,
          export_to: exportTo,
        },
        default_template_id: defaultTemplateId,
      },
    };
    updateCustomer(currentCustomer?.shortname, newCustomerData).then(
      (res: any) => {
        if (res.data) {
          dispatch(setAlert("Company Updated!", "success"));
          getCustomerData();
          getConnectorStatus();
        } else {
          const error =
            res.e.response.data.errors || res.e.response.data.details;
          dispatch(setAlert(JSON.stringify(error), "error"));
          getCustomerData();
          getConnectorStatus();
        }
      },
    );
  };

  const handleConnectorChange = () => {
    getConnectorStatus();
  };

  const handleCustomerPermissionsUpdate = () => {
    updateCustomerPermissions(currentCustomer?.shortname, {
      module_permissions: permissions,
    }).then((res: any) => {
      res.data
        ? dispatch(setAlert("Company Permissions Updated!", "success"))
        : dispatch(
            setAlert(JSON.stringify(res.e.response.data.errors), "error"),
          );
    });
  };

  const handleDefaultTemplateChange = (
    _name: string,
    template: {
      value: string;
      label: string;
    },
  ) => {
    setState({ defaultTemplateId: template.value });
  };

  return (
    <BaseLayout
      title="Organization Settings"
      tabs={tabs}
      activeTab={activeTab}
      handleTabChange={handleTabClick}
    >
      <Switch>
        <Route path="/admin/settings/general" exact>
          <General
            company={currentCustomer?.shortname}
            shortname={shortname}
            name={name}
            timezone={timezone}
            language={language}
            street={street}
            city={city}
            zip={zip}
            country={country}
            color={color}
            logo={logo}
            archived={archived}
            internals={internals}
            handleSelectChange={handleSelectChange}
            handleTextInputChange={handleTextInputChange}
            handleColorChange={handleColorChange}
            handleToggle={handleTogglePermissions}
            handleInternalsChange={handleInternalsChange}
            setLogo={setLogo}
          />
        </Route>
        <Route path="/admin/settings/roles" exact>
          <Permissions
            handleToggle={handleTogglePermissions}
            permissions={roles}
          />
        </Route>
        <Route path="/admin/settings/settings" exact>
          <BasicSettings
            customer={shortname || currentCustomer?.shortname}
            handleToggle={handleToggle}
            handleSelectChange={handleSelectChange}
            handleTextInputChange={handleTextInputChange}
            sendNotifications={sendNotifications}
            supportNumber={supportNumber}
            keylessAccessExtraTimeMinutes={keylessAccessExtraTimeMinutes}
            maxReservationTokenHours={maxReservationTokenHours}
            showCanReserveFlag={showCanReserveFlag}
            createDriverAutomatically={createDriverAutomatically}
            createDriverByDetectedId={createDriverByDetectedId}
            filterVehiclesByTrackingDevice={filterVehiclesByTrackingDevice}
            tripsCutAtMidnight={tripsCutAtMidnight}
            prefillVehicleDataByVIN={prefillVehicleDataByVIN}
            externalIdField={externalIdField}
            editExternalIdField={editExternalIdField}
            co2Values={co2Values}
            handleCO2ValueChange={handleCO2ValueChange}
            display_attachments={display_attachments}
            connectorStatus={connectorStatus}
            handleConnectorChange={handleConnectorChange}
            exportOptions={exportTo}
            handleFieldChange={handleFieldChange}
            defaultTemplateId={defaultTemplateId}
            handleDefaultTemplateChange={handleDefaultTemplateChange}
            internals={internals}
            handleInternalsChange={handleInternalsChange}
          />
        </Route>
        <Route path="/admin/settings/reservationSettings" exact>
          <JSONEditor
            value={reservationSettings}
            jsonChanged={handleReservationConfigChange}
            titleText="Reservation Settings Config"
          />
        </Route>
        <Route path="/admin/settings/invoiceSettings" exact>
          <JSONEditor
            value={vehicleActivitySettings}
            jsonChanged={handleInvoiceConfigChange}
            titleText="Invoice Settings Config"
          />
        </Route>
        <Route path="/admin/settings/notificationsSettings" exact>
          <JSONEditor
            value={notificationsSettings}
            jsonChanged={handleNotificationsConfigChange}
            titleText="Notifications Settings"
          />
        </Route>
        <Route path="/admin/settings/tariffs" exact>
          <InternalBillingTariffs />
        </Route>
        <Redirect to="/admin/settings/general" />
      </Switch>
      <div className={classes.buttons}>
        <div className={classes.save}>
          <KButton
            children="Save"
            onClick={(): void =>
              activeTab === "roles"
                ? handleCustomerPermissionsUpdate()
                : handleCustomerUpdate()
            }
          />
        </div>
      </div>
    </BaseLayout>
  );
};

export default OrgSettings;
